import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import logo from '../../img/bitFist.svg';
import bitText from '../../img/bitText.svg';

const HeaderStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: white;
  border-bottom: 1px solid #cdcdcd;
  .bandsintownLogo {
    .bandsintownFist {
      margin-right: 8px;
    }

    amp-img:first-child{
      margin-right: 8px;
    }
  }
  .navigationLinks {
    line-height: 70px;
    font-size: 18px;
    padding-right: 20px;
    a {
      text-decoration: none;
      color: inherit;
      margin-right: 48px;
      &:last-child {
        margin-right: 25px;
      }
    }

    a:hover {
      color: #259998;
      text-decoration: underline;
    }
  }
  @media (max-width: 700px) {
    .bandsintownText {
      display: none;
    }

    amp-img:last-child {
      display: none;
    }
  }
  @media (max-width: 500px) {
    .navigationLinks {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      padding-left: 40px;
      font-size: 14px;
      a {
        margin: 0;
        display: block;
      }
    }
  }
`;

const Header = () => (
  <HeaderStyle>
    <a className="bandsintownLogo" href="/">
      <img layout="fixed" className="bandsintownFist" src={logo} alt="Bandsintown Logo"/>
      <img layout="fixed" className="bandsintownText" src={bitText} alt="Bandsintown"/>
    </a>
    <div className="navigationLinks">
      <Link to="/news">News</Link>
      <Link to="/reviews">Reviews</Link>
      <Link to="/features">Features</Link>
      <Link to="/lists">Lists</Link>
    </div>
  </HeaderStyle>
);

export default Header;
